<template>
  <v-card>
    <form-header
      :fullscreen="false"
      :title='$lang("reservations.promotions.title")'
    ></form-header>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" xs="12" md="12">
            <v-list>
              <template v-for="(promotion, p) in promotions">
                <v-list-item :key="promotion.id">
                  <v-list-item-icon>
                    <v-icon color="warning">mdi-sale</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{promotion.name}} - {{promotion.discount}}%
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <v-btn-toggle
                        v-if="promotion.weekdays.length < 7"
                        dense
                        multiple
                      >
                      <v-btn plain x-small v-for="(day, d) in promotion.weekdays" :key="d">
                        {{$lang(`main.weekdays_ultra_short.${day}`)}}
                      </v-btn>
                      </v-btn-toggle>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-action-text>
                      <v-btn small color="primary" @click="apply(promotion)">{{ $lang('main.words.apply') }}</v-btn>
                    </v-list-item-action-text>
                  </v-list-item-action>
                </v-list-item>
                <v-divider
                  v-if="p < promotions.length - 1"
                  :key="p"
                ></v-divider>
              </template>
            </v-list>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="close()">{{ $lang("main.close") }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

import {
  GET_PROPERTY_PROMOTIONS_COLLECTION,
} from "@/store/property-promotions/actions";

export default {
  name: "PromotionsForm",
  props: {
    options: {
      type: Object,
      required: false,
      default() {
        return {};
      }
    }
  },
  beforeMount() {
    this.getPromotions();
  },
  methods: {
    getPromotions() {
      let filters = {
        sortBy: 'name',
        order: 'asc',
      };

      if (this.options.property_id) {
        filters.property_id = this.options.property_id;
      }

      if (this.options.start_date && this.options.end_date) {
        filters.booking = {
          end_date: this.options.end_date,
          start_date: this.options.start_date,
        };
      }

      this.$store.dispatch(GET_PROPERTY_PROMOTIONS_COLLECTION, filters);
    },
    close() {
      this.$emit('close');
    },
    apply(promotion) {
      this.$emit('applied', promotion);
      this.close();
    }
  },
  computed: {
    ...mapState({
      promotions: state => state.propertyPromotions.getCollectionRequest.collection,
    }),
  },
};
</script>

<style scoped>

</style>
